"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _templateObject;
const _excluded = ["width", "thickness", "color", "verticalMargin"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function Divider(_ref) {
  let {
      width = 100,
      thickness = 1,
      color,
      verticalMargin = 15
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    width: width,
    thickness: thickness,
    color: color,
    verticalMargin: verticalMargin
  }, props));
}
const Container = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: ", "px;\n  width: ", "%;\n  background-color: ", ";\n  margin: ", "px 0;\n"])), _ref2 => {
  let {
    thickness
  } = _ref2;
  return thickness;
}, _ref3 => {
  let {
    width
  } = _ref3;
  return width;
}, _ref4 => {
  let {
    color,
    theme
  } = _ref4;
  return color || theme.colors.NEUTRAL.SELECTED;
}, _ref5 => {
  let {
    verticalMargin
  } = _ref5;
  return verticalMargin;
});
var _default = exports.default = Divider;